export default "__VITE_ASSET__CpAzIvfn__"